export const ensureArray = function ensureArray<T>(array: T[] | null): T[] {
  if (!array) return []
  if (!Array.isArray(array)) return []

  return array
}
